<footer class="footer">
        <span>{{year}} Copyright@StraViso</span>
</footer>